import CountryRepository from '../domain/countryRepository';
import httpService from '../../../services/httpService';

export default class RemoteCountryRepository extends CountryRepository {
  async getAll() {
    const { data } = await httpService.get('/paises')
    return data
  }
}
